<div data-test-id="pdf-modal-print-wrapper" class="print-wrapper" *transloco="let t; read: 'myResults'">
  <div data-test-id="pdf-modal-header" class="header d-flex align-items-center">
    <span data-test-id="pdf-modal-filename">{{ data?.filename }}</span>
    <a data-test-id="pdf-modal-print" class="btn btn-default ml-3 print p-1 pb-1" href="javascript:;" (click)="print()">
      <span data-test-id="pdf-modal-print" class="notranslate material-icons">print</span>
    </a>
    <a data-test-id="pdf-modal-download" class="btn btn-default ml-3 print p-1 pb-1" href="javascript:;" (click)="download()">
      <span data-test-id="pdf-modal-get_app" class="notranslate material-icons">get_app</span>
    </a>
    <input data-test-id="pdf-modal-startprint" type="hidden" (click)="prntr.printCanvas('')" id="startprint">
    <div data-test-id="pdf-modal-close-cont" class="ml-auto">
      <span data-test-id="pdf-modal-close" class="notranslate material-icons close-btn" mat-dialog-close
        (click)="close()">close</span>
    </div>
  </div>
  <div data-test-id="pdf-modal-content" class="content px-3 pt-3">
    <p data-test-id="pdf-modal-p" class="text-center" [hidden]="!pdfIsLoading">{{ t('printPDFDocument') }}</p>
    <pdf-viewer data-test-id="pdf-modal-viewer" [id]="'pdf-modal-id'" [src]="data?.pdfUrl" [render-text]="true"
      [external-link-target]="'blank'" (on-progress)="onProgress($event)" (page-rendered)="pageRendered($event)"
      (text-layer-rendered)="textLayerRendered($event)" class="pdf-viewer display-none"
      [class.pdf-viewer--relative]="positionPdfViewerRelative" (after-load-complete)="handlePdfLoaded()">
    </pdf-viewer>
  </div>
</div>
